import { Select } from "@amzn/awsui-components-react";
import React, { useState } from "react";

export default function CoaSegmentSelector(props:
    {
        segment:string, 
        isEditable:boolean, 
        alreadySelected: string[], 
        coaSegmentOptions: { label: string; value: string }[],
        onSegmentChanged: (oldSegment:string, newSegment?: string) => void
    }){
    const {segment, alreadySelected, onSegmentChanged, coaSegmentOptions, isEditable} = props;

    const [
        selectedOption,
        setSelectedOption
      ] = React.useState(coaSegmentOptions.find(x => x.value === segment) || { label: segment, value: segment } as any);
    
    return <div className="placeholderCell placeholderCoaSelector">
        <Select data-class="basicDropdown"
            selectedOption={selectedOption}
            disabled={!isEditable}
            onChange={({ detail }) => {
                setSelectedOption(detail.selectedOption);
                onSegmentChanged(segment, detail.selectedOption.value);
            }}
            placeholder="Select COA segment"
            options={coaSegmentOptions.filter(x => !alreadySelected.includes(x.value))}            
        />
    </div>
}